import styled from 'styled-components';

export const AssignedToColumnWrap = styled.div`
  max-width: 300px;
`;

export const EditIconButton = styled.button`
  cursor: pointer;
  padding: 5px;
  transition:
    color,
    background-color 300ms ease;

  svg,
  path {
    transition:
      color,
      fill 300ms ease;
  }

  &:hover {
    svg path {
      fill: #000000;
    }

    svg.approve {
      color: green !important;
    }

    svg.reject {
      color: red !important;
    }
  }
`;

export const AssigneeDefaultStateWrapper = styled.div`
  display: flex;
  align-items: center;

  svg {
    margin-right: 5px;
  }

  ${EditIconButton} {
    visibility: hidden;
  }

  .project-table-tr:hover & {
    ${EditIconButton} {
      visibility: visible;
    }
  }
`;

export const AssigneeSelectStateWrapper = styled.div`
  display: flex;
  align-items: center;

  button {
    margin-left: 5px;
  }
`;
